import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { BettingEventDto, BettingStatus } from '@playball/common/dto/Betting';
import { DataListResponse } from '@playball/common/dto/Common';
import { useAuth } from '../../context/AuthContext';
import CommonUtil from '../../util/CommonUtil';
import BettingStatusBadge from './BettingStatusBadge';

const BettingListPage: React.FC = () => {
    const { fetchApi } = useAuth();
    const [bettingEvents, setBettingEvents] = useState<BettingEventDto[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const hasFetched = useRef(false);

    useEffect(() => {
        if (hasFetched.current) {
            return;
        }

        hasFetched.current = true;

        const fetchBettingEvents = async () => {
            try {
                // 임시 API URL, 실제 API로 교체 필요
                const data = await fetchApi('/api/betting') as DataListResponse<BettingEventDto>;
                setBettingEvents(data.dataList);
            } catch (e: any) {
                setError(e.message);
            } finally {
                setLoading(false);
            }
        };

        fetchBettingEvents();
    }, [fetchApi]);

    if (loading) {
        return <div className="text-center mt-5">로딩 중...</div>;
    }

    if (error) {
        return <div className="alert alert-danger mt-5">에러: {error}</div>;
    }

    return (
        <>
            <section className="guide-hero-section py-5">
                <div className="container text-center">
                    <h1 className="display-5 fw-bold">베팅 이벤트</h1>
                </div>
            </section>
            <div className="container mt-4">
                {bettingEvents.length === 0 ? (
                    <div className="alert alert-info text-center">현재 진행 중인 베팅 이벤트가 없습니다.</div>
                ) : (
                    <div className="list-group">
                        {bettingEvents.map((event) => (
                            <Link
                                key={event.id}
                                to={`/betting/${event.id}`}
                                className="list-group-item list-group-item-action flex-column align-items-start mb-3 border rounded shadow-sm p-3"
                            >
                                <div className="d-flex w-100 justify-content-between align-items-center">
                                    <h5 className="mb-0 text-primary fw-bold">{event.title}</h5>
                                    <BettingStatusBadge status={event.status} className="p-2" />
                                </div>
                                <div className="small text-muted pt-2 mt-2 border-top">
                                    <p className="mb-1"><strong>기간:</strong> {CommonUtil.getLocalDateTimeString(event.start_at)} ~ {CommonUtil.getLocalDateTimeString(event.end_at)}</p>
                                    
                                    {event.selected_option && <p className="mb-1"><strong>나의 선택:</strong> {event.selected_option === 'A' ? event.option_a : event.option_b}</p>}

                                    {event.status === 'finished' && event.winning_option && (
                                        <p className="mb-1">
                                            <strong>결과: </strong>
                                            {event.selected_option ? (
                                                event.selected_option === event.winning_option ? (
                                                    <span className="text-success fw-bold">적중! (+{event.winning_reward} 포인트)</span>
                                                ) : (
                                                    <span className="text-danger fw-bold">빗나감</span>
                                                )
                                            ) : (
                                                <span>참여하지 않음 ({event.winning_option === 'A' ? event.option_a : event.option_b} 승리)</span>
                                            )}
                                        </p>
                                    )}
                                </div>
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default BettingListPage;
